export type SortCallback<T> = (a: T, b: T) => number;
